module.exports = __webpack_public_path__ + "static/media/uk.e5564902.svg";